var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaybook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.046875,0,0,0.046875,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,392L448,24C448,10.7 437.3,0 424,0L80,0C35.8,0 0,35.8 0,80L0,448C0,483.35 28.65,512 64,512L436,512C442.6,512 448,506.6 448,500L448,492C448,485.4 442.6,480 436,480L432.7,480C428.7,459.8 429.5,430.3 433.1,414.2C441.8,410.6 448,402 448,392ZM404.3,480L64,480C46.33,480 32,465.67 32,448C32,430.33 46.33,416 64,416L404.3,416C401.4,434.8 401.2,459.6 404.3,480ZM416,384L64,384C52.28,384 41.45,387.38 32,392.88L32,80C32,53.5 53.5,32 80,32L416,32L416,384Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.371213,0,0,0.371213,148.524,110.876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.4,214.7L72.4,6.6C43.8,-10.3 0,6.1 0,47.9L0,464C0,501.5 40.7,524.1 72.4,505.3L424.4,297.3C455.8,278.8 455.9,233.2 424.4,214.7Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybook);
export default __webpack_public_path__ + "static/media/playbook.849f8e4a2c948b055d73d4be1510c428.svg";
export { ForwardRef as ReactComponent };